import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './pages/Contact';
import Header from './components/Header';
import Footer from './components/Footer';
import Privacy from './pages/PrivacyStatement';
import Home from './pages/Home';
import About from './pages/About';
import Event from './pages/EventPage';
import Links from './pages/Links';
import DeelEvenement from './pages/DeelEvenement';
import WatHerdenkenWij from './pages/WatHerdenkenWij';
import VideosPage from './pages/VideosPage'
import VideoPage from './pages/VideoPage'
import SpeechesPage from './pages/SpeechesPage'
import SpeechPage from './pages/SpeechPage'
import AdminPage from './pages/AdminPage'

import { Analytics } from "@vercel/analytics/react"

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        {/* Header - Full Width */}
        <Header setMenuOpen={setMenuOpen} />

        {/* Sidebar Menu */}


        {/* Main Content */}
        <main className="flex-grow w-full p-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/over-ons" element={<About />} />
            <Route path="/onderzoek" element={<Links />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/wat-herdenken-wij" element={<WatHerdenkenWij />} />
            <Route path="/deel-je-evenement" element={<DeelEvenement />} />
            <Route path="/events/:slug" element={<Event />} />
            <Route path="/privacy-verklaring" element={<Privacy />} />
            <Route path="/videos" element={<VideosPage />} />
<Route path="/videos/:slug" element={<VideoPage />} />
<Route path="/toespraken" element={<SpeechesPage />} />
<Route path="/toespraken/:slug" element={<SpeechPage />} />
<Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
